import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        backgroundColor: theme.palette.grey[200],
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 250px)'
    },
    list_container: {
        padding: '10px',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        gridColumnGap: '10px'
    },
    no_data_container: {
        padding: '10px',
        display: 'flex',
        flexGrow: 1,
    }
}));

export {useStyles}